import axiosInstance from "app/axiosInstance";

class ObjectTypesService {
  static getObjectTypesByAccount = async (accountId: string) => {
    return await axiosInstance.get(`/accounts/${accountId}/objecttypes`);
  };
}

export default ObjectTypesService;
